import React, { Component } from 'react'
import Modal from 'react-modal'

import '../assets/css/bootstrap.min.css'

class Faq extends Component {
  render() {
    return (
      <div className='wfp--story faq'>
        <div>
          <div className='wfp--wrapper wfp--wrapper--width-sm'>
            <div>
              <h2>COMP Frequently Asked Questions (FAQs)</h2>
              <h3 className='text-primary'>COMP CONTENTS</h3>
              <h4>Is there a generic template of the COMP to use as guidance?</h4>
              <p>The generic template can be found in the manual. Follow the links:</p>
              <ul>
                <li>
                  Template:{' '}
                  <a href='https://docs.wfp.org/api/documents/WFP-0000100263/download/'>
                    https://docs.wfp.org/api/documents/WFP-0000100263/download/
                  </a>
                </li>
                <li>
                  Manual:{' '}
                  <a href='https://planning.manuals.wfp.org/en/planning/31country-operations-management-plan/'>
                    https://planning.manuals.wfp.org/en/planning/31country-operations-management-plan/
                  </a>
                </li>
              </ul>
              <h4>What is the distinction between the automated section and the narrative section?</h4>
              <p>
                The first section reflects tables that are generated automatically with data coming from COMET (for the
                logframe and beneficiary figures) and WINGS (budget). These tables include "Line of Sight",
                "Beneficiaries" and "Transfer modalities".
              </p>
              <p>
                The second section reflects information that the Country Office manually enters in the COMP Narratives
                Platform. This includes:
              </p>
              <ul>
                <li>Transfer Modalities Narrative</li>
                <li>Table of Prioritized Activities</li>
                <li>Prioritization Plan Narrative</li>
              </ul>
              <h4>
                Our Country Office does not have the Implementation Plan yet for the I/CSP, how can I fill the
                narratives and table?
              </h4>
              <p>
                If the Implementation Plan is not there yet, you should already have some idea about the contributions.
                In this case, you do not need to put the exact percentages, you can estimate them. And if nothing
                changes in the strategy of work, these numbers can be used in the COMP.
              </p>
              <h4>What basis should I follow to do the prioritization strategy?</h4>
              <p>
                The prioritization strategy varies from country to country and depending on the COMP and it is
                subjective to the Country Office. If there is an emergency, your prioritization will be a different
                strategy than if you have long-term development goals. The important thing is to be coherent and use the
                narrative precisely to explain that and to use it as a resource mobilisation tool. Also, use the
                narrative to show the impact of the gap in funding with details on what would happen if forecasted
                funding does not occur.
              </p>
              <h4>Can we do the prioritization based on Funding Forecast of 2020?</h4>
              <p>The COMP that you are preparing now is the COMP 2020 so you can use the 2020 forecast.</p>
              <h4>Can I mention names of some donors?</h4>
              <p>
                Do not mention donor names. You can mention the host government if applicable, but no donors should be
                mentioned.
              </p>
              <h4>We are having Budget Revisions (BR) soon. How does that reflect in the COMP?</h4>
              <p>
                It all depends on the size and the scope of the BRs. There is no need to revise the COMP if the BR only
                changes rates or adjusts a little the number of beneficiaries. However, we would need one if the BR
                includes a new activity and/or strategic outcome, reorganizes something in the line of sight, or
                substantially modifies numbers of beneficiaries or transfer modalities. Some scenarios can be found in
                the COMP manual, <a href="https://planning.manuals.wfp.org/en/planning/31country-operations-management-plan/how-to-prepare-comp-after-a-budget-revision/" target="_blank">here</a>.
              </p>
              <h4>We have two channels for the COMP info:</h4>
              <p>
                <strong>PDF COMP as stand-alone document</strong>: The COMP is officially published once a year – an initial COMP that
                goes to the EB at the same time as the I/CSP, OR an annual one that is prepared and published for the
                EB.2 in November. In case there is a BR, it is up to the Country Office and the Regional Bureau to see
                if the BR is such that the COMP needs to be revised. We have included some examples in the manual, and
                we have contacted some Country Offices that have recently done BRs to update their texts. Once produced,
                these COMPs are available in a repository – you can view this COMP as a picture of the operation.
              </p>
              <p>
                <strong>COMP contents in the I/CSP Data Portal</strong>: which is continuously visible. The Portal takes the latest
                approved or validated version of the logframe and Needs Based Plan, which means that when the BR is
                approved, it will display the BR once the new logframe and Needs Based Plan are validated (for any given
                year). In this case, we also ask Country Offices that undergo BRs to check if they need to change their
                narratives. Sometimes, we take the initiative and contact the Country Offices to change, or to revise if
                we see narratives do not match the new figures, as the Portal is still very new. It is also welcome if
                you do it from the Country Office/Regional Bureau, as you know the figures much better, of course.
              </p>
               <h3 className='text-primary'>COMP NARRATIVES PLATFORM</h3>
              <h4>I am receiving an error message while writing my narratives on the Platform, what is the problem?</h4>
              <p>
                The narratives parts have a limit of 2500 characters or some 350 words. Once exceeded, the error message
                would appear: You can enter maximum 2500 characters.
              </p>
              <h4>I cannot comment or edit as it says "Read Only", what is the problem?</h4>
              <p>
                Please make sure clicked the correction version with the green tick sign. As for regional bureau
                reviewers, you can only edit/comment the version that is submitted by the Country Office and has status
                "RB Review".
              </p>
              <h4>Is it the Country Office or the Regional Bureau that submits the final COMP to HQ/RMP?</h4>
              <p>
                This depends on the changes. If the document was sent back to Country Office and there is no need to
                review again by the Regional Bureau (i.e. very clear changes requested), the Country Office can send it
                directly to HQ.
              </p>
              <h3 className='text-primary'>DATA AND SYSTEM-RELATED (COMET, WINGS)</h3>
              <h4>Data is not displaying in the COMP Narratives Platform, what could be the problem?</h4>
              <p>For the automated parts of the COMP to work, the Country Office should ensure that:</p>
              <ul>
                <li>
                  The budget has been released (approved) in WINGS and Needs Based Plan version 500 has been correctly
                  imported to the Financial Module (FM);
                </li>
                <li>The logframe is validated in COMET; and</li>
                <li>The Needs Based Plan includes adjusted beneficiary data in COMET – regardless of the status.</li>
              </ul>
              <h4>How can I review details in the Needs Based Plan (NBP) once it is in COMET?</h4>
              <p>
                To review the Needs Based Plan in COMET there is no need to return it to draft. For example, if you
                click on the "Adjusted Beneficiary Totals" it will display the latter for the overall duration of the
                I/CSP.
              </p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

// Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement(Faq)

export default Faq
